import styled from 'styled-components'
import { hiddenScrollBar } from 'common/scroll-bar'

const LessonsFullPathStyled = styled.div`
  display: ${({ show }) => (show ? 'block' : 'none')};
  .show-path {
    display: none;
    cursor: pointer;
    user-select: none;
  }
  .title-full-path {
    display: flex;
    align-items: center;
    padding: 1rem;
    background-color: var(--sky);
    box-sizing: border-box;
    justify-content: space-between;
    button {
      padding: 5px;
    }
    a {
      display: flex;
      align-items: center;
    }
    /* cursor: pointer; */
    h2 {
      margin: 0 8px;
      flex-grow: 1;
    }
  }
  .chapter-title {
    display: flex;
    padding: 0 1rem;
    h3 {
      flex-grow: 1;
      padding: 1rem;
      border-bottom: 1px solid #ffffff33;
      box-sizing: border-box;
    }
    .title-dot-container {
      position: relative;
      margin-right: .5rem;
      display: flex;
      align-items: center;
      &::before {
        position: absolute;
        top: 0;
        bottom: 0;
        width: 2px;
        right: 0;
        left: 0;
        margin: 0 auto;
        content: '';
        background: var(--white);
      }
    }
    .title-dot {
      position: relative;
      min-width: 16px;
      min-height: 16px;
      border-radius: 10px;
      background: var(--turquoise);
    }
  }
  .chapter-path:first-of-type .title-dot-container::before {
    top: 50%;
  }
  .chapter-path:last-of-type  a:last-of-type .lesson-dot-container::after {
    display: none;
  }
  @media(min-width: 1024px) {
    display: block;
    max-width: 280px;
    z-index: 2;
    .full-path-wrapper {
      overflow-x: hidden;
      width: 280px;
    }
    .chapter-title {
      min-width: 216px;
      padding-right: 0px;
    }
    .title-full-path h2 {
      min-width: 176px;
    }
    .lesson-title-container {
      min-width: 220px;
      box-sizing: border-box;
    }
    .show-path{
      width: 280px;
      justify-content: flex-start;
      box-sizing: border-box;
      font: var(--regular);
      background: var(--sky);
      font-weight: 500;
      font-family: var(--secondaryFont);
      color: var(--secondary);
      display: flex;
      align-items: center;
      padding: 16px 16px 24px;
      .arrow-container {
        transform: rotateZ(0deg);
        margin-right: 8px;
        border-radius: 50%;
        background: var(--secondary);
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        svg {
          position: relative;
          right: 1.05px;
        }
      }
    }
    .title-full-path {
      div {
        min-width: 40px!important;
      }
      button {
        display: none;
      }
    }
    .lesson-full-path { 
      h4 {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
    .lessons-list {
      ${hiddenScrollBar}
      overflow-y: auto;
      overflow-x: hidden;
      max-height: calc(100vh - 230px);
    }
    &.desktop-hidden {
      .full-path-wrapper {
        width: 88px;
      }
      .lessons-list {
        overflow-y: auto;
        overflow-x: hidden;
        max-height: calc(100vh - 80px);
      }
      .title-full-path {
        display: none;
      }
      .show-path-text {
        visibility: hidden;
      }
      .chapter-title h3 {
        visibility: hidden;
      }
      .title-full-path h2 {
        visibility: hidden;
      }
      .lesson-title-container {
        visibility: hidden;
      }
      .chapter-title,
      .lesson-full-path {
        box-sizing: border-box;
        width: 88px;
        padding: 0;
        height: 56px;
        margin: 0;
      }
      .title-dot-container,
      .lesson-dot-container {
        min-width: 88px;
        margin: 0;
        height: 100%;
      }
      .title-dot-container {
        justify-content: center;
      }
      .lesson-active .lesson-dot-container {
        margin-left: -4px;
      }
      .arrow-container {
        margin-left: 8px;
        transform: rotateZ(180deg);
      }
    }
  }
`

const LessonFullPathStyled = styled.div`
  cursor: pointer;
  display: flex;
  padding: 0 1rem 0 0.75rem;
  &.lesson-active {
    background: var(--neutral100);
    border-left: 4px solid var(--secondary);
    padding-left: 8px;
  }
  .lesson-title-container {
    flex-grow: 1;
    padding: 1rem .5rem;
    border-bottom: 1px solid #ffffff33;
  }
  .lesson-dot-container {
    margin-right: 8px;
    min-width: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    &::before, &::after {
      position: absolute;
      top: 0;
      bottom: 0;
      width: 2px;
      right: 0;
      left: 0;
      margin: 0 auto;
      content: '';
      background: var(--white);
    }
    &::before {
      bottom: calc(50% + 12px);
    }
    &::after {
      top: calc(50% + 12px);
    }
    span {
      font: var(--smallBold);
      line-height: 16px;
    }
  }
  .lesson-dot {
    height: 24px;
    position: absolute;
  }
  &:hover {
    background: var(--neutral90);
  }
  .circle-bg {
    stroke: var(--neutral20);
  }
  @media (min-width: 1024px) {
    padding: 0 0 0 0.75rem;
    padding-left: ${({ active }) => active && '8px'};
  }
`

export {
  LessonsFullPathStyled,
  LessonFullPathStyled,
}
